import Tabs from "@/components/Usados/Tabs";
import CrearActividadTab from "./actividadesTab/crear";
import ListarActividadTab from "./actividadesTab/listar";
import TableroActividades from "./actividadesTab/tablero";
import { useState } from "react";

export default function ActividadesTab() {
  const [activeTab, setActiveTab] = useState("Tablero");
  const [actividadParaEditar, setActividadParaEditar] = useState<any>(null);

  const handleEditar = (actividad: any) => {
    setActividadParaEditar(actividad);
    setActiveTab("crear");
  };

  const handleFinalizado = () => {
    setActividadParaEditar(null);
    setActiveTab("Tablero");
  };

  const tabs = [
    { value: "Tablero", label: "Tablero Kanban", content: <TableroActividades onEdit={handleEditar} /> },
    { value: "Listar", label: "Lista Detallada", content: <ListarActividadTab onEdit={handleEditar} /> },
    {
      value: "crear",
      label: actividadParaEditar ? "Editar actividad" : "Crear actividad",
      content: (
        <CrearActividadTab
          actividad={actividadParaEditar}
          onSuccess={handleFinalizado}
          onCancel={() => { setActividadParaEditar(null); setActiveTab("Tablero"); }}
        />
      ),
    }
  ];

  return (
    <Tabs
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      activeTextClass="text-green-800"
      activeBorderClass="border-green-800"
      activeGlowClass="bg-green-800/40"
    />
  );
}
